var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainSpectrum3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1218,
    height: 160,
    viewBox: "0 0 1218 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.631,
    y1: 1,
    x2: 0.123,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd6363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2b17d"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_1959",
    "data-name": "\\uC0AC\\uAC01\\uD615 1959",
    d: "M80,0H1218a0,0,0,0,1,0,0V160a0,0,0,0,1,0,0H80A80,80,0,0,1,0,80v0A80,80,0,0,1,80,0Z",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainSpectrum3);
export default __webpack_public_path__ + "static/media/main_spectrum3.920fedb904bbc857c3043e869cfccbba.svg";
export { ForwardRef as ReactComponent };